import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import {
    BonusSettlementSearchSupplier,
    BonusSettlementSupplier,
    BonusSettlementSupplierOverviewDetail,
} from '../models/bonus-settlement-supplier-overview';

export class BonusSettlementsSupplierOverviewApi {
    constructor(protected baseUrl: string) {}

    public getBonusSettlementsSupplierOverview(
        id: number,
        searchParams: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<BonusSettlementSupplier>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/bonus-settlements/${id}/suppliers`, { params: searchParams }),
            response => response.data
        );
    }

    public getBonusSettlementsSupplierOverviewDetails(
        id: number
    ): Promise<ApiResult<BonusSettlementSupplierOverviewDetail>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/bonus-settlements/${id}/details`),
            response => response.data
        );
    }

    public getBonusSettlementSearchSuppliers = async (
        id: number,
        params?: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<BonusSettlementSearchSupplier>>> =>
        safeRequest(
            () => request.get(`${this.baseUrl}/bonus-settlements/${id}/search-suppliers`, { params }),
            response => response.data
        );

    public deleteBonusSettlementSupplier(
        bonusSettlementId: number,
        supplierId: number
    ): Promise<ApiResult<BonusSettlementSupplier>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/bonus-settlements/${bonusSettlementId}/suppliers/${supplierId}`),
            response => response.data
        );
    }

    public postAddBonusSettlementSupplier(
        bonusSettlementId: number,
        supplierId: number
    ): Promise<ApiResult<BonusSettlementSupplier | void>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/bonus-settlements/${bonusSettlementId}/add-supplier`, { supplierId }),
            response => response.data
        );
    }

    public postInviteBonusSettlementSuppliers(bonusSettlementId: number): Promise<ApiResult<BonusSettlementSupplier>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/bonus-settlements/${bonusSettlementId}/invite-suppliers`),
            response => response.data
        );
    }

    public postReclaimBonusSettlementSuppliers(
        bonusSettlementId: number,
        bonusSettlementSupplierId: number
    ): Promise<ApiResult<null>> {
        return safeRequest(
            () =>
                request.post(
                    `${this.baseUrl}/bonus-settlements/${bonusSettlementId}/suppliers/${bonusSettlementSupplierId}/reclaim`
                ),
            () => null
        );
    }

    public postRevertReclaimBonusSettlementSuppliers(
        bonusSettlementId: number,
        bonusSettlementSupplierId: number
    ): Promise<ApiResult<null>> {
        return safeRequest(
            () =>
                request.post(
                    `${this.baseUrl}/bonus-settlements/${bonusSettlementId}/suppliers/${bonusSettlementSupplierId}/revert-reclaim`
                ),
            () => null
        );
    }

    public postReopenBonusSettlementSupplier(
        bonusSettlementId: number,
        bonusSettlementSupplierId: number
    ): Promise<ApiResult<null>> {
        return safeRequest(
            () =>
                request.post(
                    `${this.baseUrl}/bonus-settlements/${bonusSettlementId}/suppliers/${bonusSettlementSupplierId}/reopen`
                ),
            () => null
        );
    }

    public postRemindBonusSettlementSuppliers(
        bonusSettlementId: number,
        remindAll?: boolean,
        supplierBonusSettlementIds?: number[]
    ): Promise<ApiResult<BonusSettlementSupplier>> {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/bonus-settlements/${bonusSettlementId}/remind-suppliers`, {
                    remindAll,
                    supplierBonusSettlementIds,
                }),
            response => response.data
        );
    }
    public postCompleteBonusSettlementSuppliers(
        bonusSettlementId: number,
        completeAll?: boolean,
        supplierBonusSettlementIds?: number[]
    ): Promise<ApiResult<BonusSettlementSupplier>> {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/bonus-settlements/${bonusSettlementId}/complete-suppliers`, {
                    completeAll,
                    supplierBonusSettlementIds,
                }),
            response => response.data
        );
    }
}
